import { render, staticRenderFns } from "./TreeList.vue?vue&type=template&id=0f58a3fa&"
import script from "./TreeList.vue?vue&type=script&lang=js&"
export * from "./TreeList.vue?vue&type=script&lang=js&"
import style0 from "./TreeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f58a3fa')) {
      api.createRecord('0f58a3fa', component.options)
    } else {
      api.reload('0f58a3fa', component.options)
    }
    module.hot.accept("./TreeList.vue?vue&type=template&id=0f58a3fa&", function () {
      api.rerender('0f58a3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Producao/TreeList.vue"
export default component.exports